import './Consultancy.css'
export default function Consultancy(){

    return(

        <div>
        <div className="consultancy"></div>
        <img src="https://www.shutterstock.com/image-vector/abstract-business-logo-vector-logotype-600w-228422890.jpg" alt="" style={{position:'absolute',height:'26rem',width:'32rem',margin:'-27rem 3.2rem'}}/>

        <span style={{position:'absolute',fontSize:'3.4rem',fontWeight:'600',margin:'-7rem 9.3rem',opacity:'0.8',color:'white'}}>Consultancy</span>


        <span style={{position:'absolute',height:'3rem',width:'10rem',
        margin:'-28.3rem 25.2rem',backgroundColor:'green'}}></span>

        <span style={{position:'absolute',height:'3rem',width:'10rem',
        margin:'-28.2rem 26.5rem',color:'white',fontSize:'2rem',fontWeight:'600'}}>20% Off</span>
        
        </div>
    )
}